import { runtimeConfig } from '../config';
import { cookieStorage } from './cookies';

const amplifyConf = {
  Auth: {
    userPoolId:
      runtimeConfig.COGNITO_USER_POOL_ID ||
      process.env.REACT_APP_COGNITO_USER_POOL_ID ||
      '',
    userPoolWebClientId:
      runtimeConfig.COGNITO_CLIENT_ID ||
      process.env.REACT_APP_COGNITO_CLIENT_ID ||
      '',
    region:
      runtimeConfig.COGNITO_REGION ||
      process.env.REACT_APP_COGNITO_REGION ||
      'us-east-1',
    storage: cookieStorage,
  },
};

const getAmplifyConfig = () => {
  return {
    ...amplifyConf,
    endpoint:
      runtimeConfig.COGNITO_ENDPOINT || process.env.REACT_APP_COGNITO_ENDPOINT,
    oauth: {
      domain:
        runtimeConfig.COGNITO_DOMAIN || process.env.REACT_APP_COGNITO_DOMAIN,
      scope: (
        runtimeConfig.COGNITO_SCOPES || process.env.REACT_APP_COGNITO_SCOPES
      )?.split(','),
      redirectSignIn: `${window.location.origin}/signin-oidc`,
      redirectSignOut: `${window.location.origin}/login`,
      responseType: 'code',
    },
  };
};

export { getAmplifyConfig };
export default amplifyConf;
